export default "__VITE_ASSET__DxiNlzos__"